<div class="mat-elevation-z8">
  <table
    mat-table
    class="full-width-table"
    [dataSource]="dataSource"
    aria-label="Score Chart"
  >
    <!-- Id Column -->
    <ng-container matColumnDef="scoreRange">
      <th mat-header-cell *matHeaderCellDef>Score Range</th>
      <td mat-cell *matCellDef="let row">{{ row.scoreRange }}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="grade">
      <th mat-header-cell *matHeaderCellDef>Grade</th>
      <td mat-cell *matCellDef="let row">{{ row.grade }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
